import { HttpClient } from "@angular/common/http";
import { inject, Injectable, Signal } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { firstValueFrom } from "rxjs";
import { IdProofingGetVerificationSessionResponse, IdProofingInitiateResponse, IdProofingValidateRequest } from "./id-proofing.models";

@Injectable({
    providedIn: "root"
})
export class IdProofingService {
    private readonly httpClient = inject(HttpClient);

    public initiateAsync(): Promise<IdProofingInitiateResponse> {
        return firstValueFrom(this.httpClient.post<IdProofingInitiateResponse>(`/api/idproofing/initiate`, null));
    }

    public validateAsync(request: IdProofingValidateRequest): Promise<void> {
        return firstValueFrom(this.httpClient.post<void>(`/api/idproofing/validate`, request));
    }

    public getVerificationSession(): Signal<IdProofingGetVerificationSessionResponse> {
        return toSignal(this.httpClient.get<IdProofingGetVerificationSessionResponse>(`/api/idproofing/verificationsession`));
    }

    public confirmAsync(): Promise<void> {
        return firstValueFrom(this.httpClient.post<void>(`/api/idproofing/confirm`, null));
    }

    public submitManualAsync(file: File): Promise<void> {
        const formData = new FormData();
        formData.append("file", file);
        return firstValueFrom(this.httpClient.post<void>(`/api/idproofing/manual`, formData));
    }
}
